const convertToTwoDecimalValue = (data : string) => {
    return parseFloat(data).toFixed(2);
}

export default convertToTwoDecimalValue;